import React, { useState } from "react";
import { FieldArray, FormikProps } from "formik";
import { Col, Row } from "reactstrap";
import { Trash, Plus, ArrowUp, ArrowDown } from "react-bootstrap-icons";

import { QuestionDto, QuestionOptionDto } from "../../../services/dto";
import Form from "../../../assets/vfx/form/form";
import { Constants } from "../../../assets/utils/lib/constants";

interface QuestionOptionProps {
    formikProps: FormikProps<QuestionDto>;
    title?: string;
    style?: React.CSSProperties;
}

const QuestionOption = (props: QuestionOptionProps) => {
    const [draggedIndex, setDraggedIndex] = useState<number | null>(null);

    const handleDragStart = (index: number) => {
        setDraggedIndex(index);
    };

    const handleDragOver = (e: React.DragEvent, index: number) => {
        e.preventDefault();
        if (draggedIndex === null || draggedIndex === index) return;

        const options = [...(props?.formikProps.values?.options ?? [])];
        const draggedItem = options[draggedIndex];
        options.splice(draggedIndex, 1);
        options.splice(index, 0, draggedItem);

        options.forEach((opt, i) => (opt.order = i * 100));
        props?.formikProps.setFieldValue("options", options);
        setDraggedIndex(index);
    };

    const addNewOption = () => {
        const newOption: QuestionOptionDto = {
            id: Constants.emptyGuid,
            name: "",
            questionId: props?.formikProps.values.id ?? Constants.emptyGuid,
            answerTypeId: undefined,
            order: (props?.formikProps.values.options?.length ?? 0) * 100,
        };
        props?.formikProps.setFieldValue("options", [
            ...(props?.formikProps.values.options || []),
            newOption,
        ]);
    };

    const moveOption = (index: number, direction: "up" | "down") => {
        const options = [...(props?.formikProps.values?.options ?? [])];
        const target = direction === "up" ? index - 1 : index + 1;
        if (target < 0 || target >= options.length) return;
        [options[index], options[target]] = [options[target], options[index]];
        const updatedOptions = options.map((opt, i) => ({
            ...opt,
            order: i * 100,
        }));
        props?.formikProps.setFieldValue("options", updatedOptions);
    };

    return (
        <FieldArray name="options">
            {({ remove }) => (
                <div>
                    <Form.PanelSection
                        iconClassName="bi bi-list-check"
                        title={props.title ?? "Options"}
                        style={props.style}
                    >

                        {props?.formikProps.values.options
                            ?.slice()
                            .sort((a, b) => a.order - b.order)
                            .map((option, index) => (
                                <div key={index} draggable onDragStart={() => handleDragStart(index)} onDragOver={(e) => handleDragOver(e, index)} className="rounded bg-white" >
                                    <Row>
                                        <Col>
                                            <Form.Text
                                                label={`Option ${index + 1}`}
                                                name={`options[${index}].name`}
                                                onChange={(e: any) =>
                                                    props?.formikProps.setFieldValue(`options[${index}].name`, e.target.value)
                                                }
                                                required
                                            />
                                        </Col>
                                        <Col xs={3} className="d-flex justify-content-end">
                                            {index > 0 && (
                                                <Form.Button
                                                    type="button"
                                                    style={{ border: "none", backgroundColor: "transparent", fontSize: 24, paddingTop: 0, paddingBottom: 0 }}
                                                    onClick={() => moveOption(index, "up")} >
                                                    <ArrowUp />
                                                </Form.Button>
                                            )}
                                            {index <
                                                (props?.formikProps.values.options?.length ?? 0) - 1 && (
                                                    <Form.Button
                                                        type="button"
                                                        style={{ border: "none", backgroundColor: "transparent", fontSize: 24, paddingTop: 0, paddingBottom: 0 }}
                                                        onClick={() => moveOption(index, "down")} >
                                                        <ArrowDown />
                                                    </Form.Button>
                                                )}
                                            {props?.formikProps.values?.options?.length !== 1 && (
                                                <Form.Button
                                                    type="button"
                                                    style={{ border: "none", backgroundColor: "transparent", fontSize: 24, float: "right", paddingTop: 0, paddingBottom: 0 }}
                                                    onClick={() => {
                                                        remove(index);
                                                        const newOptionsArray = [...(props?.formikProps.values.options ?? []),];
                                                        newOptionsArray.splice(index, 1);
                                                        props?.formikProps.setFieldValue("options", newOptionsArray);
                                                    }}
                                                >
                                                    <Trash style={{ color: "red" }} />
                                                </Form.Button>
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                            ))}

                        <Form.Button type="button" className="mt-2" onClick={addNewOption}>
                            <Plus /> Add Option
                        </Form.Button>
                    </Form.PanelSection>
                </div>
            )}
        </FieldArray>
    );
};

export default QuestionOption;